<div class="wrapper-carousel"
  [class.dots-inside]="areDotsInside"
  [class.full-height]="fullHeight">
  <div class="content">
    <div class="slider">
      <div class="slides"
        #carouselContent
        [class.scroll-hidden]="scroll"
        (scroll)="onScroll($event)"
        (cdkObserveContent)="onContentChange($event)">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
  </div>
</div>
<div class="carousel__pagination" [class.hotels-dots]="styleHotelDots">
  <app-ds-pagination
    class="carousel__pagination-control"
    [type]="pagenationType"
    [defaultPage]="currentPosition + 1"
    [pages]="dots?.length"
    (pageHasChanged)="moveCarouselByDot($event)">
  </app-ds-pagination>
</div>
